// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"889717bf","540":"8b4cfbec","926":"194127ae"}[chunkId] + ".chunk.js";
};